import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { LoginService } from './login.service';
import { Observable, map } from 'rxjs';
import { LogoutService } from './auth/logout.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private routes: Router,
    private _loginservice: LoginService,
    private _logoutService: LogoutService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this._loginservice.getUserId() != null) {
      return true;
    } else {
      this.routes.navigate(['/authentication/login']);
      return false;
    }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this._loginservice.getUserId() == null) {
      this.routes.navigate(['/authentication/login']);
      return false;
    }

    return this._loginservice.validateActiveSession().pipe(
      map(isValid => {
        if (!isValid) {
          this._logoutService.logout();
          return false;
        }

        return true;
      })
    );
  }
}
